import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {CDFItem, CDFBulkOrderItemCandidate} from "../cdf/cdf.gql-model";

export interface BulkOrderItemSelectionData {
  assignable: CDFItem;
}

function isDifferent(a: CDFItem, b: CDFBulkOrderItemCandidate) {
  if (!b) {
    return !!a.bulkOrderItemId;
  }

  return a.bulkOrderItemId !== b.id;
}

@Component({
  templateUrl: "./bulk-order-item-selection-dialog.template.pug",
})
export class BulkOrderItemSelectionDialogComponent
  extends DialogComponent<BulkOrderItemSelectionData, boolean>
  implements BulkOrderItemSelectionData {
  assignable: CDFItem;
  result: boolean = false;

  static show(dialogService: DialogService, assignable: CDFItem): Promise<boolean> {
    return dialogService.showDialog(BulkOrderItemSelectionDialogComponent, {assignable});
  }

  select(candidate: CDFBulkOrderItemCandidate) {
    this.result = isDifferent(this.assignable, candidate);

    if (candidate) {
      this.assignable.associateBulkOrderItem(candidate);
    } else {
      this.assignable.clearBulkOrderItem();
    }

    this.close();
  }

  close() {
    super.close();
  }

  constructor(dialogService: DialogService) {
    super(dialogService);
  }
}
